import { fetchMFAPreference } from 'aws-amplify/auth';
import { useQuery, useQueryClient } from 'react-query';

export const MFA_PREFERENCE_QUERY_KEY = 'mfaPreference';

/**
 * Current user's MFA preference from Cognito (which methods are enabled).
 */
export function useMfaPreferenceQuery() {
  return useQuery(MFA_PREFERENCE_QUERY_KEY, () => fetchMFAPreference(), {
    staleTime: 5 * 60 * 1000,
  });
}

export function useInvalidateMfaPreference() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries(MFA_PREFERENCE_QUERY_KEY);
}
